
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/finances",
      function () {
        return require("private-next-pages/[company]/finances/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/finances"])
      });
    }
  